
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","fill-rule":"evenodd","d":"M9.77 14.64l-1.891 1.9A5.006 5.006 0 014.337 18h-.84a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h.84c.796 0 1.559-.317 2.121-.88l1.9-1.89 1.411 1.41zm4.35 1.9a5.07 5.07 0 002.882 1.4V20a.5.5 0 00.85.35l3.001-3a.51.51 0 000-.71l-3.001-3a.5.5 0 00-.85.36v1.92a2.987 2.987 0 01-1.46-.8L12.41 12l3.131-3.12a3 3 0 011.46-.8V10a.5.5 0 00.851.35l3.001-3a.51.51 0 000-.71l-3.001-3a.5.5 0 00-.85.36v2.06a5.064 5.064 0 00-2.881 1.4L11 10.59 7.879 7.46A5.006 5.006 0 004.337 6h-.84a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h.84c.796 0 1.559.317 2.121.88l7.663 7.66z"}})])
          )
        }
      }
    